// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1b8Tn","footer":"Form_footer__3eTGq"};